import React, {useState} from "react";
import CustomContainer from "../../../components/CustomContainer";
import Loader from "../../../components/Loader";
import {Col, Row} from "react-bootstrap";
import CardForm from "../../../components/form/CardForm";
import {LinkIconButton} from "../../../components/button/LinkIconButton";
import models from "../../../helpers/models";
import {useHistory} from "react-router-dom";
import fields from "./PackingLineCreateFormConfig";
import { useTranslation } from 'react-i18next';


const PackingLineCreatePage = (props) => {
    const { t } = useTranslation();
    const [loader, setLoader] = useState(false);



    const history = useHistory()

    function onSaved(data, id) {
        history.push("line/" + id)
    }




    return (
        <>
            <Loader loader={loader}/>
            <CustomContainer
                title={<>{t("forms.new_line")}</>}
                parent={
                    <LinkIconButton
                        tooltip={t("menu.packing_lines")}
                        icon={models.icons.line}
                        link={"/lines"}
                        props={props}
                    />
                }

            >

                <Col>
                    <Row>
                        <CardForm
                            title={t("forms.add_new_line")}
                            setLoader={setLoader}
                            fields={fields}
                            width={12}
                            postSaved={onSaved}
                            api={"line"}
                        />


                    </Row>

                </Col>
            </CustomContainer>

        </>
    );
};

export default PackingLineCreatePage;
